import type { IsoDate, KeyFigure, SourceName } from "../../types"
import type {
  HealthMissionCategoryName,
  HealthMissionMissionName,
} from "./healthMission.enum"

export enum HealthMissionsGoalsEnum {
  FIRST_QUARTILE = "firstQuartile",
  EXPLOITED_POTENTIAL_75 = "exploitedPotential75",
}
export type HealthMissionsGoals = Record<HealthMissionsGoalsEnum, number>

export interface ApiFinancialDataHealthMissions {
  pharmacyId: number
  source: SourceName
  periodStartDate: IsoDate
  periodEndDate: IsoDate
  categories: Category[]
}
interface Category {
  name: HealthMissionCategoryName
  missions: Mission[]
  sales?: Sales
  units?: Units
}
interface Mission {
  name: HealthMissionMissionName
  acts: Act[]
  sales?: Sales
  units?: Units
  goals?: HealthMissionsGoals
}

interface Act {
  name: string
  sales?: Sales
  units?: Units
}

type Sales = KeyFigure

type Units = KeyFigure
